import { getCompetitionResults } from "../../../api";

export const fetchCompetitionResults = async ({
  provider,
  discipline,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  day = null,
}) => {
  const { data } = await getCompetitionResults({
    provider,
    discipline,
    competitionIds,
    season,
    widgetConfigurationId,
    day,
  });

  return data;
};